import { OrganizationDM } from "./organization_dm";

export class OrganizationStructureLabelDM {
  constructor({ organization = {}, level = "", label = "" }) {
    this.organization = organization;
    this.level = level;
    this.label = label;
  }

  static fromJson(json) {
    return new OrganizationStructureLabelDM({
      organization: OrganizationDM.fromJson(json["organization"]),
      level: json["level"],
      label: json["label"],
    });
  }
}
